"use client";

import * as React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { DayPicker } from "react-day-picker";
import { cn } from "@/lib/utils";
import { buttonVariants } from "@/components/ui/button";
import "react-day-picker/dist/style.css";
export type CalendarProps = React.ComponentProps<typeof DayPicker>;
function Calendar({
  className,
  modifiers,
  showOutsideDays = true,
  ...props
}: CalendarProps) {
  return <DayPicker showOutsideDays={showOutsideDays} className={cn("p-3", className)} captionLayout="dropdown" modifiersClassNames={{
    selected: "bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground",
    today: "bg-accent text-accent-foreground",
    outside: "text-muted-foreground opacity-50",
    disabled: "text-muted-foreground opacity-50",
    range_middle: "aria-selected:bg-accent aria-selected:text-accent-foreground",
    ...modifiers
  }} {...props} data-sentry-element="DayPicker" data-sentry-component="Calendar" data-sentry-source-file="calendar.tsx" />;
}
Calendar.displayName = "Calendar";
export { Calendar };